import router from '@/router';

export function getRouteQuery() {
  const { currentRoute } = router;
  const { query } = currentRoute.value;
  return JSON.parse(JSON.stringify(query));
}